import { SOCKET } from 'flaivy-react/reducers/action-type';

const initialState = {
  loading: false,
  entities: [],
  error: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_INTEGRATION_RUNS_WITH_ERRORS': {
      return {
        ...state,
        entities: action.payload.data.rows,
      };
    }

    case SOCKET('INTEGRATION_RUN_RESET'): {
      const { fullEntity } = action.payload;
      return {
        ...state,
        entities: state.entities.filter(
          entity => entity.integration.id !== fullEntity.id,
        ),
      };
    }

    default:
      return state;
  }
};

export default reducer;
